module.exports = __webpack_public_path__ + "static/media/ico-filters.3f59ea6d.svg";